export const USER_REGISTER_STATE_RESET = 'USER_REGISTER_STATE_RESET';
export const USER_REGISTER_PENDING = 'USER_REGISTER_PENDING';
export const USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS';
export const USER_REGISTER_FAILURE = 'USER_REGISTER_FAILURE';
export const USER_REGISTER_VERIFY_PENDING = 'USER_REGISTER_VERIFY_PENDING';
export const USER_REGISTER_VERIFY_SUCCESS = 'USER_REGISTER_VERIFY_SUCCESS';
export const USER_REGISTER_VERIFY_FAILURE = 'USER_REGISTER_VERIFY_FAILURE';
